export interface FileUploadDTO {
  uploadedSize: number
  uuid: string
  chunkNum: number
  imageUrl: string
  error?: string
}

export type SectionsResponseType = {
  sections: {
    data: string
    id?: number
  }[]
}

export enum Country {
  RU = 'RU',
  AM = 'AM',
  KZ = 'KZ',
  BY = 'BY',
  UZ = 'UZ',
  KG = 'KG',
  GE = 'GE',
  TJ = 'TJ',
  TM = 'TM',
}

export const CurrencyFromCountry: Record<Country, string> = {
  [Country.RU]: '₽',
  [Country.AM]: '֏',
  [Country.KZ]: '₸',
  [Country.BY]: 'Br',
  [Country.KG]: 'с',
  [Country.UZ]: 'Soʻm',
  [Country.GE]: '₾',
  [Country.TJ]: 'SM',
  [Country.TM]: 'TMT',
}

export const enum SupportedLanguages {
  RU = 'ru',
  GE = 'ka',
}

export type BaseOption<TValue = string> = {
  value: TValue
  label: string
}

/** Роли пользователей в системе. */
export enum USER_PERMISSION {
  /** Отсутствие роли, нет доступов. */
  PERM_NONE = 'PERM_NONE',
  /** Сотрудник партнерского ПВЗ */
  PERM_EMPLOYEE = 'PERM_EMPLOYEE',
  /** Собственник партнерского ПВЗ. */
  PERM_OWNER = 'PERM_OWNER',
  /** Сотрудник фирменного ПВЗ. */
  PERM_FIRM_EMPLOYEE = 'PERM_FIRM_EMPLOYEE',
  /** Собственник фирменного ПВЗ. */
  PERM_FIRM_OWNER = 'PERM_FIRM_OWNER',
  /** Роль аудитора, который проводит инвентаризацию для закрытых пвз */
  PERM_AUDITOR = 'PERM_AUDITOR',
}

export type ResponseListData<T> = {
  data: T
  total?: number
}

export type PaginationType = {
  page: number
  pageSize: number
}

export const enum hostName {
  RU = 'pvz-promo.wb.ru',
  GE = 'pvz-promo.wildberries.ge',
}
